import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import {
  fetchSubscribers,
  fetchAdminSubscriptions,
  fetchSubscriptions,
  fetchSubscriptionTypes,
  fetchPricing,
  fetchFactures,
  fetchAdminUsersList,
  createAdminUser,
  fetchDemoUsersList,
  createDemoUser,
} from "../services/administrationService";

const STALE_TIME = 2 * 60 * 1000;
const baseQueryOptions = { staleTime: STALE_TIME, refetchOnWindowFocus: false };

const SUBSCRIBERS_QK = ["administration", "subscribers"];
const ADMIN_SUBSCRIPTIONS_QK = ["administration", "subscriptions"];
const SUBSCRIPTIONS_QK = ["subscriptions"];
const SUBSCRIPTION_TYPES_QK = ["subscription-types"];
const PRICING_QK = ["pricing"];
const FACTURES_QK = ["factures"];
const ADMIN_USERS_QK = ["administration", "users"];
const DEMO_USERS_QK = ["administration", "demo-users"];

export const useSubscribers = (options = {}) =>
  useQuery({ queryKey: SUBSCRIBERS_QK, queryFn: fetchSubscribers, ...baseQueryOptions, ...options });

export const useAdminSubscriptions = (options = {}) =>
  useQuery({ queryKey: ADMIN_SUBSCRIPTIONS_QK, queryFn: fetchAdminSubscriptions, ...baseQueryOptions, ...options });

export const useSubscriptions = (options = {}) =>
  useQuery({ queryKey: SUBSCRIPTIONS_QK, queryFn: fetchSubscriptions, ...baseQueryOptions, ...options });

export const useSubscriptionTypes = (options = {}) =>
  useQuery({ queryKey: SUBSCRIPTION_TYPES_QK, queryFn: fetchSubscriptionTypes, ...baseQueryOptions, ...options });

export const usePricing = (options = {}) =>
  useQuery({ queryKey: PRICING_QK, queryFn: fetchPricing, ...baseQueryOptions, ...options });

export const useFactures = (options = {}) =>
  useQuery({ queryKey: FACTURES_QK, queryFn: fetchFactures, ...baseQueryOptions, ...options });

export const useAdminUsers = (options = {}) =>
  useQuery({ queryKey: ADMIN_USERS_QK, queryFn: fetchAdminUsersList, ...baseQueryOptions, ...options });

export const useDemoUsers = (options = {}) =>
  useQuery({ queryKey: DEMO_USERS_QK, queryFn: fetchDemoUsersList, ...baseQueryOptions, ...options });

export const useCreateAdminUser = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createAdminUser,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ADMIN_USERS_QK });
      toast.success("Compte Administrateur ajouté avec succès", { autoClose: 3000 });
    },
    onError: () => toast.error("Echec de l'ajout d'un compte administrateur", { autoClose: 3000 }),
  });
};

export const useCreateDemoUser = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: createDemoUser,
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: DEMO_USERS_QK });
      toast.success("Compte Démo ajouté avec succès", { autoClose: 3000 });
    },
    onError: () => toast.error("Echec de l'ajout d'un compte démo", { autoClose: 3000 }),
  });
};
